import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "./i18n";

export const Loader = ({ onDone }) => {
  const { t } = useLang();
  const [n, setN] = useState(0);
  const [show, setShow] = useState(true);

  useEffect(() => {
    const start = performance.now();
    let id;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / 1500);
      setN(Math.round(p * 100));
      if (p < 1) id = requestAnimationFrame(tick);
      else { setShow(false); onDone(); }
    };
    id = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(id);
  }, [onDone]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100] bg-[#050505] flex flex-col items-center justify-center"
          exit={{ clipPath: "inset(0 0 100% 0)" }}
          initial={{ clipPath: "inset(0 0 0% 0)" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <img src="/img/logo.gif" alt="Off Grid" className="w-40 h-40 og-invert" />
          <div className="mt-6 f-mono text-xs tracking-[0.3em] text-zinc-400">{t("loader")}</div>
          <div className="absolute bottom-6 right-6 f-disp text-[18vw] md:text-[12vw] leading-none text-white/90 tabular-nums">
            {String(n).padStart(3, "0")}
          </div>
          <div className="absolute bottom-0 left-0 h-[3px] bg-[#FF2A2A]" style={{ width: `${n}%` }} />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
